<template>
    <div class="modal-overlay" v-if="isOpen">
        <div class="modal-content">
            <div id="map" class="map-container"></div>
            <button style="margin-top: 10px;" @click="fecharModal">Fechar</button>
        </div>
    </div>
</template>


<script setup>
    import { watch } from "vue";
    import L from "leaflet";
      
    const props = defineProps({
        isOpen: Boolean,
        showMarker: Boolean,
        coordenadasIniciais: { type: Object, default: () => ({ lat: -28.935225, lng: -49.485324 }) },
    });
      
    const emit = defineEmits(["close", "coordenadaSelecionada"]);
      
    let map = null;
    let marker = null;

    const customIcon = L.icon({
        iconUrl: require('@/assets/icons/mapMarker.svg'), // Caminho para imagem
        iconSize: [26, 26], // Tamanho do ícone (largura, altura)
        iconAnchor: [10, 20], // Ponto de ancoragem (base do ícone)
        popupAnchor: [0, -38] // Ponto onde o popup aparecerá
    });
  
    watch(
        () => props.isOpen, (newValue) => {
            if (newValue) {
                setTimeout(() => {iniciarMapa();}, 200);
            }
        }
    );
  
    const iniciarMapa = () => {
        const mapElement = document.getElementById("map");
        if (!mapElement) return;
      
        // Se o mapa já existir, remove antes de criar um novo
        if (map) {
            map.remove();
            map = null;
            marker = null;
        }
      
        map = L.map("map").setView([props.coordenadasIniciais.lat, props.coordenadasIniciais.lng], 13);
      
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
           attribution: "© OpenStreetMap contributors",
        }).addTo(map);
      
        // Adiciona marcador inicial caso `showMarker` esteja ativado
        if (props.showMarker) {
            marker = L.marker([props.coordenadasIniciais.lat, props.coordenadasIniciais.lng], { icon: customIcon }).addTo(map);
        }
      
        map.on("click", (e) => {
            if (marker) marker.remove();
            marker = L.marker(e.latlng, { icon: customIcon }).addTo(map);
            emit("coordenadaSelecionada", e.latlng);
        });
      
        // Garante que o mapa seja renderizado corretamente ao reabrir
        setTimeout(() => {map.invalidateSize();}, 300);
    };
  
    const fecharModal = () => {
        if (map) {
            map.remove();
            map = null;
            marker = null;
        }
        emit("close");
    };
</script>

  
<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-content {
    background: white;
    padding: 10px;
    border-radius: 8px;
    width: 750px;
    height: 500px;
}
.map-container {
    border-radius: 8px;
    height: 465px;
}
</style>